import clsx from "clsx";
import React from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { Text } from "web/react/emo/text";
import { ShippingInformation } from "web/react/pages/product/in-stock/in-stock-product-page/in-stock-product-page.context";
import * as styles from "./shipping-info.css";

export interface ShippingInfoProps {
    buyOptionId: number;
    shippingInformation: ShippingInformation[];
    direction?: "row" | "column";
}

export function ShippingInfo({
    buyOptionId,
    shippingInformation,
    direction = "column",
}: ShippingInfoProps): React.ReactElement {
    return (
        <div
            className={clsx(
                styles.container,
                direction === "column" ? styles.containerColumn : styles.containerRow
            )}
        >
            {shippingInformation.map((item, index) => (
                <div className={styles.item} key={`${buyOptionId}-shipping-info-${index}`}>
                    <SVGIcon
                        name={item.isFree ? "tick" : "plus"}
                        className={clsx(
                            styles.icon,
                            item.isFree ? styles.iconTick : styles.iconPlus
                        )}
                        overrideStyle
                    />
                    <Text textStyle="body-s">{item.info}</Text>
                </div>
            ))}
        </div>
    );
}
